import { styled } from "styled-components";

export const PaymentInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 12px 0 12px;
`;
